import { DelayedComponentLoader } from "@ch/components/Loaders/ComponentLoader/DelayedComponentLoader";
import { type FC, Suspense, lazy } from "react";

const HealthConditionHistoryPage = lazy(
  () => import("./HealthConditionHistoryPage"),
);

const HealthConditionHistoryPageLazy: FC = () => {
  return (
    <Suspense fallback={<DelayedComponentLoader />}>
      <HealthConditionHistoryPage />
    </Suspense>
  );
};

export default HealthConditionHistoryPageLazy;
